import { render, staticRenderFns } from "./editAlertNumSubmit.vue?vue&type=template&id=d92da83e&scoped=true&"
import script from "./editAlertNumSubmit.vue?vue&type=script&lang=js&"
export * from "./editAlertNumSubmit.vue?vue&type=script&lang=js&"
import style0 from "./editAlertNumSubmit.vue?vue&type=style&index=0&id=d92da83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92da83e",
  null
  
)

export default component.exports